import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Customer } from '@core/user/utilities/user.model';

export const USER_FEATURE = 'USER';
export const selectUser = createSelector(createFeatureSelector<Customer>(USER_FEATURE), state => state);
